import { useCallback } from 'react';
import { useCart } from '@/context/CartContext';
import { useToast } from '@/context/ToastContext';
import { requiresDelivery } from '@/utils/pricing';

/** Adding to the cart always confirms with a toast — pairing them here keeps that consistent. */
export function useAddToCart() {
  const { add, lines } = useCart();
  const { showToast } = useToast();

  return useCallback(
    (product, qty = 1, languages = []) => {
      // One line per book, so this is an edit whenever the book is already
      // there — and the confirmation should say so rather than claiming a
      // second copy was added.
      const already = lines.some((line) => String(line.id) === String(product.id));

      // A digital book is bought once per account; only printed copies stack.
      add(product.id, qty, languages, { single: !requiresDelivery(product) });

      const extra = languages.length > 0 ? ` (+${languages.join(', ')})` : '';
      showToast(
        already
          ? `Updated "${product.name}"${extra} in your cart`
          : `Added "${product.name}"${extra} to cart`,
      );
    },
    [add, lines, showToast],
  );
}
